import { render, staticRenderFns } from "./dimmer.vue?vue&type=template&id=9a090272"
import script from "./dimmer.vue?vue&type=script&lang=js"
export * from "./dimmer.vue?vue&type=script&lang=js"
import style0 from "./dimmer.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/dimmer.vue
// module id = PVDR
// module chunks = 0